const STATE_BY_RUN_STATUS = Object.freeze({
  queued: { state: 'queued' },
  generating: { state: 'running' },
  running_tool: { state: 'running' },
  running: { state: 'running' },
  canceling: { state: 'running', detail: 'Stopping' },
  awaiting_approval: { state: 'waiting' },
  paused: { state: 'waiting' },
  complete: { state: 'done' },
  succeeded: { state: 'done' },
  error: { state: 'failed' },
  failed: { state: 'failed' },
  canceled: { state: 'failed', detail: 'Stopped' },
  duplicate_prevented: { state: 'queued', detail: 'Skipped, a run was already going' }
});

/**
 * Maps the status of an automation run (a conversation run or a workflow run) to the execution state the
 * interface shows: queued, running, waiting (for you), done or failed, plus an optional short note.
 * An unknown status reads as queued rather than claiming an outcome.
 */
const resolveRunExecutionState = (status) => {
  return STATE_BY_RUN_STATUS[String(status || '').toLowerCase()] || { state: 'queued' };
};

export default resolveRunExecutionState;
